import { extensions } from '../extensions/Extensions';
import { FilterPipe } from './FilterPipe';
import { FilterSystem } from './FilterSystem';

extensions.add(FilterSystem);
extensions.add(FilterPipe);
